export const IMAGES = {
  hero: "https://images.pexels.com/photos/11987205/pexels-photo-11987205.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  texture: "https://images.unsplash.com/photo-1628965882741-570e75becd5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG9yZ2FuaWMlMjB0ZXh0dXJlJTIwd2FybXxlbnwwfHx8fDE3ODc1MDE2ODd8MA&ixlib=rb-4.1.0&q=85",
  family: "https://images.pexels.com/photos/27176613/pexels-photo-27176613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  familyBridge: "https://images.unsplash.com/photo-1616543791139-fdca422b7ef7?fm=jpg&q=85&w=1000&h=1290&fit=crop&crop=entropy&ixlib=rb-4.1.0",
  team: "https://images.unsplash.com/photo-1758691737124-05c5bffe46f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjB0ZWFtJTIwd2FybSUyMGxpZ2h0fGVufDB8fHx8MTc4NzUwMTY4N3ww&ixlib=rb-4.1.0&q=85",
  wheat: "https://images.unsplash.com/photo-1657626625832-2c0851cdaa9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHx3aGVhdCUyMGZpZWxkJTIwZ29sZGVuJTIwaG91cnxlbnwwfHx8fDE3ODc1MDE2ODd8MA&ixlib=rb-4.1.0&q=85",
};

export const marqueeItems = [
  "Clarity before coverage",
  "Every season, together",
  "Knowledge is the harvest",
  "Texas-grown guidance",
  "Your success is my legacy",
  "Plain language, real answers",
];

export const services = {
  individuals: {
    title: "For Individuals & Families",
    intro:
      "Health coverage shouldn't feel like a foreign language. I walk beside you — comparing plans, translating the fine print, and making sure the coverage you pay for is the coverage you actually need.",
    items: [
      { title: "Individual & Family Health Plans", desc: "Guidance through ACA marketplace and private plan options, matched to your doctors, prescriptions, and budget." },
      { title: "Medicare Guidance — Coming Soon", desc: "I'm finishing my Medicare carrier setup. Join the list and I'll reach out when I can help with Medicare questions.", cta: { label: "Join the list", to: "/contact?type=medicare-list" } },
      { title: "Dental, Vision & Supplemental", desc: "Fill the gaps with ancillary coverage that protects against the bills major medical leaves behind." },
      { title: "HSA Strategy", desc: "Learn how health savings accounts work: tax-advantaged dollars for medical costs today, in an account you keep for the future." },
      { title: "Year-Round Plan Reviews", desc: "Life changes — marriage, a new child, a new job. I review your coverage whenever your season changes." },
    ],
  },
  employers: {
    title: "Benefits Guidance for Employers",
    intro:
      "Whatever your team needs — group health, ancillary coverage, funding strategy, enrollment education, or an honest look at a PEO arrangement — I help you understand the options and weigh the trade-offs. No PEO required: most employers I work with don't have one.",
    items: [
      { title: "Group Health Plan Guidance", desc: "Plan architecture for small and mid-sized Texas businesses, balanced between cost and care." },
      { title: "Level-Funded & Alternative Funding", desc: "Funding strategies beyond traditional fully-insured plans, for the right teams." },
      { title: "Ancillary & Voluntary Benefits", desc: "Dental, vision, life, and disability options that round out a competitive package." },
      { title: "Benefits Education & Enrollment", desc: "I teach your team what they actually have, and run enrollments in plain language." },
      { title: "Renewal & Repricing Defense", desc: "Benchmark any renewal — group plan or PEO — before you sign it." },
      { title: "PEO Education & Analysis", desc: "Not a requirement, just clarity: a data-driven read on how your PEO arrangement compares to the broader market, so you can decide with real numbers." },
    ],
  },
};

export const articles = [
  {
    slug: "aca-open-enrollment-2027-texas",
    title: "ACA Open Enrollment for 2027 in Texas: pick by Dec 15 for Jan 1",
    seoTitle: "Texas ACA Open Enrollment 2027: Key Dates & Deadlines",
    excerpt:
      "Texas ACA Open Enrollment for 2027 runs Nov 1, 2026 to Jan 15, 2027. Pick a plan by Dec 15 for Jan 1 coverage. Dates, steps and local help from Kyle.",
    category: "Individuals",
    date: "November 2026",
    isoDate: "2026-11-01",
    readTime: "5 min read",
    featured: false,
    content: [
      {
        heading: "Open Enrollment for 2027 is here",
        body: [
          "Open Enrollment for 2027 individual and family health coverage is here. If you buy your own health insurance in Texas, whether you're self-employed, between jobs, retired early or your employer doesn't offer a plan, this is the window to enroll, renew or change plans for next year. Here are the dates that matter, what to check before you choose, and how to get a hand from someone local.",
        ],
      },
      {
        heading: "The 2027 dates for Texas",
        body: [
          "Texas uses the federal Marketplace at HealthCare.gov, so the federal schedule applies here.",
          "November 1, 2026: Open Enrollment begins.",
          "December 15, 2026: Last day to pick a plan for coverage that starts January 1, 2027.",
          "January 15, 2027: Open Enrollment ends. Plans picked from December 16 through January 15 start February 1, 2027.",
          "Coverage starts only after you pay your first premium, so leave time for that step too. After January 15, you can generally enroll or change plans only if you have a qualifying life event, such as losing other coverage, moving, getting married or having a baby. That's called a Special Enrollment Period.",
          "The simplest goal: have your plan picked by December 15. That way there's no gap in January, and you aren't making a rushed decision during the holidays.",
        ],
      },
      {
        heading: "Already have a Marketplace plan? Don't just let it roll over",
        body: [
          "If you have Marketplace coverage now and do nothing, you may be automatically re-enrolled for 2027. That sounds convenient, but it can leave you with surprises in January.",
          "Your plan can change. Premiums, deductibles, copays and the list of covered doctors and drugs can all change from one year to the next. In some cases a plan is discontinued and you're moved to a different one.",
          "Your financial help can change. The premium tax credit that lowers your monthly payment is based on your estimated household income for 2027. If your income, household size or job situation changed, or if you don't update your application, the amount you receive may not match what you actually qualify for. That can mean paying more each month than you need to, or owing money back at tax time.",
          "Your needs may have changed. A new diagnosis, a new prescription, a baby on the way or a planned surgery can make a different plan a better fit.",
          "Log in, update your application and look at your options before December 15, even if you end up keeping the same plan.",
        ],
      },
      {
        heading: "What to check before you pick a plan",
        body: [
          "Plans on the Marketplace come in metal levels (Bronze, Silver, Gold and, in some areas, Platinum). The level tells you how costs are split between you and the plan, not the quality of care. Here's what I'd look at for any plan you're considering.",
          "1. Your doctors. Look up each doctor, specialist and hospital you want to keep, in the specific plan you're considering. A doctor who takes one plan from an insurance company may not take every plan that company sells.",
          "2. Your prescriptions. Check each medication on the plan's drug list, and note which tier it falls in. The tier often decides what you pay at the pharmacy.",
          "3. The total cost, not just the premium. Add up twelve months of premiums plus what you'd realistically pay in a typical year and in a bad year. A low premium with a high deductible can work well for some people and poorly for others.",
          "4. The out-of-pocket maximum. This is the most you'd pay for covered care in a year. It's your worst-case number, and it's worth knowing before you need it.",
          "5. Silver plans and extra help. If your income is within certain limits, Silver plans can come with lower deductibles and copays, in addition to the premium tax credit. If you might qualify, compare Silver plans carefully before you settle on Bronze.",
          "6. HSA eligibility. Some plans are HSA-eligible, which lets you set aside pre-tax money for medical costs. If that matters to you, filter for it.",
        ],
      },
      {
        heading: "Who in Texas should pay extra attention this year",
        body: [
          "Self-employed people and small-business owners whose income moves around. Your estimate drives your financial help, so make it as realistic as you can and update it during the year if things change.",
          "Families with a change coming, such as a new baby, a child turning 26 or a move.",
          "People leaving a job or retiring early who need coverage to bridge the gap.",
          "Anyone who was automatically re-enrolled last year and hasn't looked at their plan since.",
        ],
      },
      {
        heading: "How I can help",
        body: [
          "Choosing a plan is a lot easier with someone who will sit down with you, look at your doctors, prescriptions and budget, and explain the trade-offs in plain language. That's what I do for individuals and families in The Woodlands, Houston and surrounding communities. You can read more about how I work with individuals and families on the Individuals page.",
          "There's no fee to you for my help; carriers pay my commission. If you'd like to talk it through before December 15, send me a note or call (713) 725-7413.",
        ],
      },
    ],
    faq: [
      {
        q: "When is the deadline for coverage starting January 1, 2027?",
        a: "December 15, 2026. Pick your plan by then and pay your first premium so coverage starts on January 1.",
      },
      {
        q: "What if I miss December 15?",
        a: "You can still pick a plan through January 15, 2027. Coverage would start February 1, 2027.",
      },
      {
        q: "What if I miss January 15?",
        a: "After Open Enrollment ends, you can generally enroll only with a qualifying life event, such as losing other coverage, moving, marriage or a new baby. Otherwise you'd wait for the next Open Enrollment.",
      },
      {
        q: "Will I be renewed automatically?",
        a: "Many people with Marketplace coverage are, but not everyone, and your plan or financial help may change. It's best to log in, update your application and review your options before December 15.",
      },
      {
        q: "Do I have to use HealthCare.gov in Texas?",
        a: "Texas uses HealthCare.gov for Marketplace coverage. Financial help such as the premium tax credit is available only on Marketplace plans.",
      },
      {
        q: "Does it cost anything to have you help me?",
        a: "No. There's no fee to you; carriers pay my commission.",
      },
    ],
    links: [
      { label: "Individual & family coverage", to: "/individuals" },
      { label: "Talk with Kyle", to: "/contact" },
    ],
    note: "Dates are from HealthCare.gov as of November 1, 2026. This article is for general education and isn't tax or legal advice.",
  },

  {
    slug: "decoding-your-health-plan",
    title: "Decoding Your Health Plan: Deductibles, Copays & Coinsurance",
    excerpt: "The four numbers that decide what you actually pay — explained in plain English, once and for all.",
    category: "Foundations",
    date: "July 2026",
    readTime: "4 min read",
    featured: true,
    content: [
      {
        heading: "The premium is just the entry fee",
        body: [
          "Most people shop for health insurance the way they shop for a phone plan — by comparing the monthly price. But your premium is only what you pay to have coverage. What you pay when you use it is decided by three other numbers hiding in the plan documents.",
          "Understanding those numbers is the difference between a plan that looks cheap and a plan that is cheap for the way you actually live.",
        ],
      },
      {
        heading: "The deductible: your first dollar threshold",
        body: [
          "Your deductible is the amount you pay out of pocket each year before your plan starts sharing the cost of most services. A $3,000 deductible means the first $3,000 of covered care is largely on you.",
          "Higher deductibles usually come with lower premiums, and vice versa. If you rarely see a doctor, a higher-deductible plan’s lower premium may be worth comparing. If you manage a chronic condition, the math often flips.",
        ],
      },
      {
        heading: "Copays and coinsurance: sharing the bill",
        body: [
          "A copay is a flat fee — say $30 for a primary care visit. Coinsurance is a percentage — for example, the plan pays 80% and you pay 20% of the allowed amount after your deductible.",
          "Coinsurance is where surprise bills are born. Twenty percent of a $40,000 hospital stay is a very different number than twenty percent of an office visit.",
        ],
      },
      {
        heading: "The out-of-pocket maximum: your financial ceiling",
        body: [
          "This is the most important number in your plan. Once your deductibles, copays, and coinsurance hit this ceiling in a year, the plan pays 100% of covered in-network care.",
          "Think of it as your worst-case scenario number. If that figure would devastate your savings, the plan isn't protecting you — no matter how low the premium.",
        ],
      },
      {
        heading: "The takeaway",
        body: [
          "Don't buy the premium; buy the whole picture. Add up the annual premium plus the out-of-pocket maximum, and ask whether you could comfortably cover that worst case. That's the comparison that matters — and it's exactly the kind of math I walk through with you in a consultation.",
        ],
      },
    ],
  },
  {
    slug: "texas-open-enrollment-guide",
    title: "Open Enrollment in Texas: Dates, Deadlines & Smart Moves",
    excerpt: "The once-a-year window to get individual coverage is short. Here's how to walk through it prepared.",
    category: "Enrollment",
    date: "July 2026",
    readTime: "5 min read",
    featured: false,
    content: [
      {
        heading: "The window that matters",
        body: [
          "For individual and family plans on the federal marketplace, open enrollment typically runs from November 1 through January 15. Enroll by mid-December and your coverage usually starts January 1.",
          "Miss the window and, in most cases, you'll wait until the following year — unless life hands you a qualifying event.",
        ],
      },
      {
        heading: "Special enrollment: the exceptions",
        body: [
          "Certain life changes open a special enrollment period, usually 60 days: losing job-based coverage, getting married, having or adopting a child, or moving to a new coverage area.",
          "If any of these happen mid-year, don't assume you're stuck. That's precisely the moment to call an agent.",
        ],
      },
      {
        heading: "Don't auto-renew on autopilot",
        body: [
          "Plans change every year — premiums, networks, drug lists, and deductibles all shift. The plan that fit you last year may be a poor fit now, and new options may have entered the market.",
          "A twenty-minute annual review helps you catch those changes before they catch you. For this year's dates, read ACA Open Enrollment for 2027 in Texas.",
        ],
      },
      {
        heading: "What to gather before you shop",
        body: [
          "Bring a list of your doctors, your prescriptions with dosages, and a realistic estimate of household income — that estimate determines any premium tax credits you're owed.",
          "With those three things in hand, comparing plans becomes a clear, quick exercise instead of a stressful guessing game.",
        ],
      },
    ],
    links: [
      { label: "ACA Open Enrollment for 2027 in Texas", to: "/education/aca-open-enrollment-2027-texas" },
    ],
  },
  {
    slug: "hsa-triple-tax-advantage",
    title: "The HSA: Health Care's Triple Tax Advantage",
    excerpt: "No other account in the tax code does what a health savings account does. Here's how to put it to work.",
    category: "Strategy",
    date: "July 2026",
    readTime: "4 min read",
    featured: false,
    content: [
      {
        heading: "One account, three tax breaks",
        body: [
          "A health savings account (HSA) is the only account that is tax-deductible going in, tax-free while it grows, and tax-free coming out — as long as the money pays for qualified medical expenses.",
          "Not even a 401(k) or a Roth IRA can claim all three.",
        ],
      },
      {
        heading: "The catch: you need the right plan",
        body: [
          "HSAs are only available alongside an HSA-eligible high-deductible health plan. That trade-off — a higher deductible in exchange for lower premiums and HSA access — is worth running the numbers on, especially if you're relatively healthy.",
          "Contribution limits adjust each year, and people 55 and older can contribute extra.",
        ],
      },
      {
        heading: "The long game most people miss",
        body: [
          "You don't have to spend HSA money in the year you contribute it. Many people pay small medical bills out of pocket, let the HSA stay invested, and treat it as a stealth retirement account for future health costs.",
          "After age 65, HSA funds can even be withdrawn for non-medical spending, taxed like a traditional IRA — with medical expenses still tax-free for life.",
        ],
      },
      {
        heading: "Is it right for you?",
        body: [
          "An HSA strategy isn't universal. If you expect heavy medical use, a richer plan with a lower deductible may win. This is exactly the kind of personal math I walk through with clients — no jargon, just your numbers.",
        ],
      },
    ],
  },
  {
    slug: "small-business-group-health-texas",
    title: "Group Health for Small Texas Employers: Where to Start",
    excerpt: "You don't need an HR department to offer real benefits. You need a plan that fits your team and your budget.",
    category: "Employers",
    date: "July 2026",
    readTime: "5 min read",
    featured: false,
    content: [
      {
        heading: "Why small businesses bother",
        body: [
          "In a tight Texas labor market, health benefits are often the deciding factor between your offer and a competitor's. They're also tax-deductible for the business and tax-free for employees — one of the most efficient dollars you can spend on compensation.",
        ],
      },
      {
        heading: "Your main roads in",
        body: [
          "Traditional small-group plans offer predictable premiums and familiar carrier plans. Level-funded plans may refund or credit part of any unused claims fund, depending on the plan’s terms. And CHOICE arrangements (formerly ICHRA) let you fund a fixed allowance employees use to buy their own individual plans.",
          "Each path trades cost, risk, and administrative effort differently. The right answer depends on your team's ages, health, and how much complexity you want to own.",
        ],
      },
      {
        heading: "What carriers will ask",
        body: [
          "Expect to provide a census of eligible employees — ages, ZIP codes, and family status. That census drives your rates, so accurate information means accurate quotes.",
        ],
      },
      {
        heading: "The part most owners don't know",
        body: [
          "Independent guidance costs you nothing extra. The insurance carrier pays my commission, and it's built into the rate either way. You get a guide and an advocate for the same price as going it alone.",
          "One note on how I work: structural questions — PEO arrangements, alternative funding, and HR outsourcing decisions — are handled as independent education and analysis. If a PEO move makes sense, I can help place or switch you, and I'll tell you how I'm paid.",
        ],
      },
    ],
  },
  {
    slug: "direct-primary-care-explained",
    title: "Direct Primary Care: The Membership Model Changing How Texans See the Doctor",
    excerpt: "A flat monthly membership for unlimited primary care access — no copays, no rushed visits. Here's how DPC works and who it fits.",
    category: "Innovation",
    date: "August 2026",
    readTime: "5 min read",
    featured: false,
    content: [
      {
        heading: "What direct primary care actually is",
        body: [
          "Direct Primary Care (DPC) is a membership arrangement with a primary care practice: you pay a flat monthly fee — often $50 to $150 per adult — and in return you get unlimited primary care visits with no copays, no deductibles, and no insurance billing for routine care.",
          "Because the practice isn't billing insurance, the doctor's time goes to patients instead of paperwork. Panels stay small, and the relationship stays personal.",
        ],
      },
      {
        heading: "What membership typically includes",
        body: [
          "Same-day or next-day appointments, visits that run 30 to 60 minutes instead of 7, direct phone and text access to your physician, and, at many practices, set cash prices for labs, imaging, and many generic medications.",
          "For families who feel like a number in the traditional system, the difference is not subtle — it's a different experience of health care entirely.",
        ],
      },
      {
        heading: "What it is not",
        body: [
          "DPC is not insurance, and it doesn't replace it. It covers primary care — not specialists, surgery, or hospital stays. The smart structure pairs DPC with a lower-premium, higher-deductible health plan that stands behind you for the big events.",
          "Whether that combination makes sense depends on your health, your budget and the plans available to you, and it’s worth comparing side by side.",
        ],
      },
      {
        heading: "Why I know this model well",
        body: [
          "Before founding OneHarvestCo. Benefits, I spent years directly involved in building and developing direct care and direct contracting arrangements — including DPC and concierge models. I've seen from the inside how these practices work, what they include, and the questions worth asking before you join one.",
          "For the right individual or employer, direct care isn't a fringe experiment — it's a real option, and increasingly part of forward-thinking benefits design.",
        ],
      },
      {
        heading: "Could it fit your plan?",
        body: [
          "DPC tends to shine for families who want real access to a doctor, people with ongoing primary care needs, and employers looking to pair it with level-funded plans. Whether the math works for you depends on your situation — and that's a conversation I'm glad to have, with real numbers on the table.",
        ],
      },
    ],
  },
  {
    slug: "alternative-care-models-self-funding",
    title: "The New Foundation: How Alternative Care Models Are Making Self-Funding Feasible",
    excerpt: "DPC, concierge medicine, and value-based centers of excellence are quietly removing the biggest risks of self-funded and level-funded health plans — putting them within reach of far more employers.",
    category: "Employers",
    date: "August 2026",
    readTime: "6 min read",
    featured: false,
    pdf: "/downloads/alternative-care-models-guide.pdf",
    content: [
      {
        heading: "The old barrier: risk",
        body: [
          "For decades, self-funding was a big-company game. The logic was simple: if you pay claims directly, one catastrophic diagnosis can blow through your budget. Smaller employers were told — often correctly — to stay in the fully-insured pool and swallow the annual increases.",
          "Level-funded plans softened the entry point by capping exposure with built-in stop-loss protection. But caps alone don't make a plan work. What actually determines whether self-funding succeeds is what happens to care and costs underneath the cap — and that's where the ground has shifted.",
        ],
      },
      {
        heading: "The models changing the math",
        body: [
          "Direct Primary Care replaces fee-for-service churn with a flat membership: unlimited, unhurried primary care that can catch problems early, when they're easier to address. Concierge and direct-contract arrangements do the same at a deeper level of access.",
          "Value-based centers of excellence (COEs) address the other end of the cost curve: instead of billing each piece of a knee replacement or cardiac procedure separately, COEs deliver defined procedures at defined prices — bundled, often warrantied, and measured on outcomes.",
          "Add direct contracts — where an employer's plan agrees on prices directly with specific providers — and you have an option that wasn't widely available ten years ago.",
        ],
      },
      {
        heading: "Why this unlocks self-funding",
        body: [
          "Self-funded and level-funded plans win or lose on three things: how much care costs, where it's delivered, and whether anyone is steering it. Alternative care models answer all three.",
          "DPC gives people an easy front door for everyday questions, which can help them get to the right place for care. COEs convert the biggest, scariest line items into predictable, bundled events. Direct contracts put a clear dollar price on common services.",
          "Layer that foundation under a level-funded structure and the plan becomes easier to understand and budget: everyday care has a clear front door, and the catastrophic tail is capped by stop-loss. Results vary by group, which is why the numbers need to be run for your team.",
        ],
      },
      {
        heading: "What it looks like in practice",
        body: [
          "A well-built arrangement might pair a level-funded plan with a DPC membership for every employee, steer surgeries to a value-based COE, and carve out direct contracts for imaging and labs. Employees get same-day access to a doctor who knows them; the employer gets clearer pricing on the services the plan uses most.",
          "None of this is theoretical. It's being built — deliberately, contract by contract — by people who understand both the care delivery side and the plan design side.",
        ],
      },
      {
        heading: "Why I talk about this",
        body: [
          "Before OneHarvestCo. Benefits, I spent years inside care delivery — directly involved in building out direct care and direct contracting arrangements, including DPC and concierge models. That background is why I can evaluate these arrangements on substance instead of sales decks.",
          "For the right employer, this combination of alternative care models and level-funding can be a genuinely strong structure worth evaluating. Whether you're the right employer is a data question — and answering it honestly, with real numbers instead of sales decks, is exactly what my education and analysis process is for.",
        ],
      },
    ],
  },
  {
    slug: "dpc-for-employers-deep-dive",
    title: "Deep Dive, Part 1: Direct Primary Care Inside an Employer's Health Plan",
    excerpt: "What DPC actually looks like when it's built into a group plan — the economics, the pairing with level-funding, and how to vet a practice before you bet your benefits on it.",
    category: "Deep Dive · Employers",
    date: "September 2026",
    readTime: "6 min read",
    featured: false,
    content: [
      {
        heading: "What DPC looks like inside a group plan",
        body: [
          "In an employer context, Direct Primary Care is simple: the company pays a flat monthly membership per employee — typically $50 to $150 — and every employee gets unlimited primary care with no copays. Same-day appointments, real visit lengths, direct text access to the physician.",
          "The health plan still exists for everything else. DPC doesn't replace insurance; it replaces the most-used, most-fragmented part of it.",
        ],
      },
      {
        heading: "The economics that get employers' attention",
        body: [
          "Primary care is meant to be the front door to the health system. When it's hard to reach, a simple question can turn into an urgent care visit, an ER claim, or a specialist referral instead. For employers, that shows up as claims for care that a reachable primary care doctor might have handled.",
          "A DPC membership is a fixed monthly cost, and its value depends on whether employees actually use it. The goal is easier access, earlier attention to chronic conditions, and care in the right setting. In a self-funded or level-funded plan, how employees use care shows up directly in the claims fund, so it's worth modeling with your own numbers.",
        ],
      },
      {
        heading: "Why it pairs so well with level-funding",
        body: [
          "Level-funded plans give you a fixed monthly cost with stop-loss protection on the tail. What they can't do alone is control what happens underneath the cap. DPC can add structure there by giving employees a consistent place to start for everyday care.",
          "It can also improve the employee experience. A doctor who answers texts the same day is a benefit people notice and use.",
        ],
      },
      {
        heading: "How to vet a DPC practice before you commit",
        body: [
          "Ask about panel size — a practice carrying thousands of patients per physician is just the old system wearing new clothes. Ask what's included versus billed separately: labs, imaging, procedures, after-hours access. Ask how they handle referrals and whether they help employees navigate the rest of the plan.",
          "And ask who else they serve. A DPC practice with established employer relationships has already worked through the operational bumps — onboarding, eligibility feeds, invoicing — that a solo practice new to groups will learn on your dime.",
        ],
      },
      {
        heading: "The bottom line",
        body: [
          "DPC isn't a wellness perk; it's infrastructure. For employers building a self-funded or level-funded strategy, it's usually the first brick in the foundation I evaluate — because everything else in the plan is easier to use when primary care has no copay at the point of care.",
          "Having helped build direct care arrangements firsthand, this is the vetting lens I bring — panel economics, contract terms, and service records, not brochures.",
        ],
      },
    ],
  },
  {
    slug: "value-based-coe-deep-dive",
    title: "Deep Dive, Part 2: Value-Based Centers of Excellence — Turning Big Claims Into Fixed Prices",
    excerpt: "The catastrophic claim is what keeps employers fully-insured. Value-based COEs convert those six-figure surprises into bundled, warrantied, predictable events. Here's how they work.",
    category: "Deep Dive · Employers",
    date: "September 2026",
    readTime: "6 min read",
    featured: false,
    content: [
      {
        heading: "The problem: big claims are a lottery",
        body: [
          "Ask any self-funded employer what keeps them up at night and it's not the flu shots — it's the knee replacement, the cardiac procedure, the cancer diagnosis. The price of the same surgery can vary widely from one facility to the next.",
          "Fully-insured employers pay carriers to absorb that lottery. Self-funded employers have to manage it themselves — or find a way to take the randomness out.",
        ],
      },
      {
        heading: "What a value-based COE actually is",
        body: [
          "A center of excellence is a facility or program that performs a defined set of procedures — orthopedics, cardiac, bariatric, oncology — at a bundled, pre-negotiated price. 'Value-based' means the payment is tied to outcomes, not activity: the bundle typically includes the surgery, the facility, the anesthesia, the follow-up, and often a warranty on complications.",
          "If something goes wrong in a complication window, the COE fixes it on their dime. Compare that to the traditional model, where a complication is just more billing.",
        ],
      },
      {
        heading: "The mechanics: bundles, warranties, and steerage",
        body: [
          "COEs only change your plan's math if patients actually use them — so the design usually includes steerage: waived deductibles, covered travel, or a lower employee cost-share when the member chooses the COE. Done well, the employee's share can be reduced or waived, and the plan pays a fixed, known price.",
          "The price is agreed before the procedure, and many programs measure and report outcomes. Results vary by program, so the contract terms and the outcome data are worth reading closely.",
        ],
      },
      {
        heading: "Why COEs matter more when you're self-funded",
        body: [
          "In a fully-insured plan, a six-figure claim is the carrier's problem — you just pay for it forever in renewals. In a self-funded or level-funded plan, that claim is yours, at least up to your stop-loss attachment point.",
          "Converting your biggest elective procedures into fixed-price events makes those claims predictable, and that can make the whole structure easier to budget.",
        ],
      },
      {
        heading: "Questions to ask before adopting a COE program",
        body: [
          "Which procedures are bundled, and what exactly does the bundle include? What's the warranty window for complications? How are outcomes measured and reported? And critically — how will employees be guided to the COE at the moment a procedure gets scheduled, because a program nobody uses doesn’t help anyone.",
          "That last question is where most COE arrangements quietly fail, and it's why design and communication matter as much as the contract.",
        ],
      },
    ],
  },
  {
    slug: "direct-contracts-employers-deep-dive",
    title: "Deep Dive, Part 3: Direct Contracting — Buying Healthcare Straight From the Source",
    excerpt: "What happens when a plan contracts with providers directly? How direct contracts get built, where they fit in plan design, and the questions to ask.",
    category: "Deep Dive · Employers",
    date: "September 2026",
    readTime: "6 min read",
    featured: false,
    content: [
      {
        heading: "What direct contracting means",
        body: [
          "A direct contract is exactly what it sounds like: an employer (or their plan) contracts directly with a health system, imaging center, lab, or physician group for defined services at defined rates — no carrier network in the middle.",
          "It's the oldest idea in commerce applied to health care: buy from the source and agree on the price up front.",
        ],
      },
      {
        heading: "How network pricing works",
        body: [
          "Traditional PPO networks negotiate discounts off each provider's list prices, and those list prices vary widely. That can make it hard to see what a given service actually costs.",
          "Direct contracts use actual dollar prices: this MRI costs $450, this panel of labs costs this much, this outpatient procedure is bundled at this price. Transparency isn't a feature of the arrangement — it's the entire point.",
        ],
      },
      {
        heading: "How these contracts actually get built",
        body: [
          "Building a direct contract network is unglamorous work: identifying the high-quality, high-value providers in a market, understanding their cost structures, negotiating rates that work for both sides, and then — the part everyone underestimates — building the operational plumbing so referrals, scheduling, and payment actually flow.",
          "This is work I've done firsthand — building out direct care and direct contracting arrangements, including DPC and concierge models. It's why I can walk you through a proposed arrangement and explain its pricing in plain terms.",
        ],
      },
      {
        heading: "Where direct contracts fit in plan design",
        body: [
          "You rarely direct-contract everything. The smart play is surgical: shoppable, high-frequency, high-variance services — imaging, labs, outpatient surgery, physical therapy — where price differences are extreme and quality is measurable.",
          "Around those anchors, the plan keeps a wrap network for the long tail and stop-loss for the catastrophes. The direct contracts cover the services your employees actually use every month.",
        ],
      },
      {
        heading: "The takeaway: three pieces, one structure",
        body: [
          "DPC controls everyday care. COEs fix the price of the big events. Direct contracts put clear prices on shoppable services. Together they can make self-funding and level-funding a realistic option for more employers to evaluate.",
          "If this series has a single message, it's that plan design has changed more in five years than in the previous thirty — and the employers who understand these pieces can make more informed choices. That's the conversation I love having.",
        ],
      },
    ],
  },
];

export const faqs = [
  {
    q: "Does it cost more to work with an agent?",
    a: "No. Carriers pay my commission, and it's already built into every plan's rates whether you use an agent or not. You pay the same premium either way.",
  },
  {
    q: "Are you tied to one insurance carrier?",
    a: "No. I work as an independent licensed agent, which means I compare options across the carriers I'm appointed with and recommend what fits your situation — not a quota. My loyalty is to the client, not the carrier.",
  },
  {
    q: "When can I enroll in health coverage?",
    a: "Individual marketplace open enrollment typically runs November 1 through January 15. Outside that window, qualifying life events — losing coverage, marriage, a new child, a move — open a special enrollment period. Employer plans follow your company's own enrollment calendar.",
  },
  {
    q: "I own a small business. How can you help my team?",
    a: "For employers, I start with whatever you need — group health, ancillary coverage, funding strategy, renewals, and employee education. You don't need a PEO to work with me; most employers I help don't have one. If you do have a PEO (or are considering one), I can walk you through an honest, data-driven analysis of how that arrangement compares. Either way, the first consultation costs you nothing; carriers pay my commission when you enroll.",
  },
  {
    q: "What areas do you serve?",
    a: "Kyle is a licensed Texas health insurance agent serving individuals, families, and employers in The Woodlands, Houston and surrounding communities — in person or by phone or video.",
  },
  {
    q: "What should I bring to a consultation?",
    a: "A list of your doctors and prescriptions, a rough household income estimate (it determines marketplace subsidies), your current plan documents if you have coverage, and your questions. That's it — I'll take it from there.",
  },
];
